export const checkInvoice = (order) =>
	order._ticket?.find((ticket) => ticket.invoice?.correction_number);
